module.exports = __webpack_public_path__ + "static/ar-logo-3da71e483fb00131e72222aaad4a2ab1.png";